import { range } from 'lodash';

import ProgramLanguage from 'core/ovations-api/definitions/languages/ProgramLanguage';

export const mockProgramLanguages: ProgramLanguage[] = range(0, 7).map((i) => ({
    cultureCode: `cc-${i}`,
    name: `language-${i}`,
    isActive: !!(i % 2),
    lastUpload: null,
}));

export const mockProgramLanguage = mockProgramLanguages[0];
